function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * @private
 *
 * @class SerializedCacheKey
 *
 * @classdesc
 * cache key used when the parameters should be serialized
 */
var SerializedCacheKey = function () {
  function SerializedCacheKey(key) {
    _classCallCheck(this, SerializedCacheKey);

    this.key = key;

    return this;
  }

  /**
   * @function matches
   * @memberof SerializedCacheKey
   * @instance
   *
   * @description
   * does the passed key match the key in the instance
   *W
   * @param {Array<*>} key the key to test
   * @returns {boolean} does the key passed match that in the instance
   */
  SerializedCacheKey.prototype.matches = function matches(key) {
    return key === this.key;
  };

  /**
   * @function matchesCustom
   * @memberof SerializedCacheKey
   * @instance
   *
   * @description
   * does the passed key match the key in the instance based on the custom equality function passed
   *
   * @param {Array<*>} key the key to test
   * @param {function} isEqual method to compare equality of the keys
   * @returns {boolean} does the key passed match that in the instance
   */


  SerializedCacheKey.prototype.matchesCustom = function matchesCustom(key, isEqual) {
    return isEqual(key, this.key);
  };

  return SerializedCacheKey;
}();

export default SerializedCacheKey;


//////////////////
// WEBPACK FOOTER
// ./~/filtermatrix/~/moize/es/SerializedCacheKey.js
// module id = 2173
// module chunks = 0